/**
 * Round a date to the nearest snap interval
 * @param date - The date to round
 * @param snapMinutes - The snap interval in minutes (e.g., 5 for 5-minute intervals)
 * @returns A new Date rounded to the nearest snap interval
 */
export function roundToSnap(date: Date, snapMinutes: number): Date {
  const ms = date.getTime();
  const snapMs = snapMinutes * 60 * 1000;
  return new Date(Math.round(ms / snapMs) * snapMs);
}

/**
 * Clamp a date to stay within a specific hour range on a given day
 * @param date - The date to clamp
 * @param baseDay - The reference day (year, month, day are used)
 * @param startHour - The minimum hour (0-23)
 * @param endHour - The maximum hour (0-24)
 * @returns A new Date clamped to the specified hour range
 */
export function clampToRange(
  date: Date,
  baseDay: Date,
  startHour: number,
  endHour: number
): Date {
  const minTime = new Date(baseDay);
  minTime.setHours(startHour, 0, 0, 0);
  const maxTime = new Date(baseDay);
  maxTime.setHours(endHour, 0, 0, 0);

  if (date < minTime) return minTime;
  if (date > maxTime) return maxTime;
  return date;
}
